export default "__VITE_ASSET__DQDmL28N__"